import { ProtectedContent } from '../../../HOCs/ProtectedContent'
import { ACTIONS } from '../../PermissionMapper/constants'
import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from '@lightbeamai/design-system'

export type StepTab = {
  isActive: boolean
  content: string
  onClick: () => void
}

interface IProps {
  tabs: StepTab[]
  className?: string | number | boolean | React.ReactElement
  onEditClick?: () => void
  onDeleteClick?: () => void
}

const StepsTabs = (props: IProps): React.ReactElement => {
  const { tabs, className, onEditClick, onDeleteClick } = props
  const intl = useIntl()
  return (
    <div
      className={`steps-tabs ${className || ''} button-style`}
      data-test-id="dssettings-steps-tabs"
    >
      {tabs.map((tab, i) => {
        return (
          <button
            key={i}
            className={`btn step-tab ${tab.isActive ? 'active' : ''}`}
            onClick={tab.onClick}
            type="button"
          >
            {tab.content}
          </button>
        )
      })}
      <ProtectedContent actions={[ACTIONS.DATASOURCE_ACTIONS]}>
        <div className="config-actions">
          {!!onEditClick && (
            <Button
              variant="secondary"
              size={40}
              className="btn step-tab edit"
              onClick={onEditClick}
              htmlType="button"
            >
              {intl.formatMessage({ id: 'dataSources.info.edit' })}
            </Button>
          )}
          {!!onDeleteClick && (
            <Button
              variant="secondary"
              size={40}
              className="btn step-tab delete"
              onClick={onDeleteClick}
              htmlType="button"
            >
              {intl.formatMessage({ id: 'dataSources.info.delete' })}
            </Button>
          )}
        </div>
      </ProtectedContent>
    </div>
  )
}

export default StepsTabs
